import React from 'react';
import Modal from '@paycor/picl/modal';
import Button from '@paycor/picl/button';
import styles from './UnsavedChangesModal.module.scss';
import PropTypes from 'prop-types';

UnsavedChangesModal.propTypes = {
	onCancelNavigation: PropTypes.func.isRequired,
	onSaveAndContinue: PropTypes.func.isRequired,
	showUnsavedChangesModal: PropTypes.bool.isRequired,
	translate: PropTypes.func.isRequired
};

function UnsavedChangesModal({ onCancelNavigation, onSaveAndContinue, showUnsavedChangesModal, translate }) {
	const saveContinueButtonText = translate('okay', 'Okay');
	return (
		<Modal
			show={showUnsavedChangesModal}
			size={Modal.Sizes.default}
			title={translate('Unsaved_Changes', 'Unsaved Changes')}
			showClose={true}
			backdrop={true}
			onClose={() => {
				onCancelNavigation();
			}}
			body={
				<div>
					<p>{translate('Unsaved_Changes_Message', 'You have unsaved changes. Please Save or Cancel your changes.')}</p>
				</div>
			}
			footer={
				<div className={styles.pullRight}>
					<Button type={Button.Types.PRIMARY} onClick={onSaveAndContinue}>
						{saveContinueButtonText}
					</Button>
				</div>
			}
		/>
	);
}

export default UnsavedChangesModal;
